import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'Qué Incluye',
    href: '#incluye'
  }, {
    label: 'Beneficios',
    href: '#beneficios'
  }, {
    label: 'Testimonios',
    href: '#testimonios'
  }];
  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md" data-id="element-57">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
          <div className="flex items-center justify-between h-16" data-id="element-59">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2
          }} className="flex items-center gap-2" data-id="element-60">
              <span className="text-2xl" data-id="element-61">🎨</span>
              <span className="text-lg sm:text-xl font-bold text-red-700" data-id="element-62">
                MegaPack Arte
              </span>
            </motion.div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8" data-id="element-63">
              {navLinks.map((link, index) => <motion.a key={link.href} href={link.href} initial={{
              opacity: 0,
              y: -20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.1 * index
            }} className="text-gray-700 hover:text-red-700 font-medium transition-colors duration-200" data-id="element-64">
                  {link.label}
                </motion.a>)}
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 rounded-md text-gray-700 hover:text-red-700 hover:bg-gray-100 transition-colors" aria-label="Toggle menu" data-id="element-65">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-66" /> : <MenuIcon className="h-6 w-6" data-id="element-67" />}
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-68">
        {isMobileMenuOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsMobileMenuOpen(false)} className="fixed inset-0 bg-black/50 z-40 md:hidden" data-id="element-69" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'tween',
          duration: 0.3
        }} className="fixed top-16 right-0 bottom-0 w-64 bg-white shadow-2xl z-50 md:hidden" data-id="element-70">
              <div className="flex flex-col p-6 space-y-4" data-id="element-71">
                {navLinks.map((link, index) => <motion.a key={link.href} href={link.href} onClick={handleLinkClick} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: index * 0.1
            }} className="text-lg font-medium text-gray-700 hover:text-red-700 py-3 border-b border-gray-200 transition-colors" data-id="element-72">
                    {link.label}
                  </motion.a>)}
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}